'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {

    // for link to tab
    var urlHash = document.location.hash,
        navTabs = $('.nav-tabs', this),
        tabContent = $('.tab-content', this),
        url = document.location.toString();

    //$('a[data-toggle="tab"]').on('shown.bs.tab',
    //    function (e) {
    //        e.preventDefault();
    //    });

    if (navTabs.length === 0) return;

    if (url.match('#')) {
        navTabs.find('a[href="#' + url.split('#')[1] + '"]').tab('show');
    }

    navTabs.on('click', 'a', function (e) {
        e.preventDefault();
        $(this).tab('show');

        // update hash without write to history
        if (history.replaceState) history.replaceState(undefined, undefined, this.hash);
    });

    if (tabContent.find(urlHash).length === 0 && tabContent.find('.active').length === 0) {
        navTabs.find('li:first-child').addClass('active');
        tabContent.find('.tab-pane:first-child').addClass('active');
    }

    $('#moreAnotation', this).click(function (e) {
        e.preventDefault();

        $('a[href="#longAnnotation"]').tab('show');

        var anotationOffsetTop = $('#longAnnotation').offset().top;

        $('html, body').animate({
            scrollTop: anotationOffsetTop - 200
        }, 1000);
    });
};

var $ = require("jquery");

;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/initializers/tabs.js
// module id = 942
// module chunks = 0